import React from 'react';
import Sidebar from '../components/Layout/Sidebar';
import { Container } from 'react-bootstrap';
/*export const StatisticsPage = () => (
  <div className="d-flex">
    <Sidebar />
    <Container className="p-4">
      <h2>Statistics</h2>
      <p>This section will be implemented in future updates.</p>
    </Container>
  </div>
);*/
export const BillingPage = () => (
  <div className="d-flex">
    <Sidebar />
    <Container className="p-4">
      <h2>Billing & Invoices</h2>
      <p>This section will be implemented in future updates.</p>
    </Container>
  </div>
);
/*export const TicketsPage = () => (
  <div className="d-flex">
    <Sidebar />
    <Container className="p-4">
      <h2>Support Tickets</h2>
      <p>This section will be implemented in future updates.</p>
    </Container>
  </div>
);*/
export const ProfilePage = () => (
  <div className="d-flex">
    <Sidebar />
    <Container className="p-4">
      <h2>Profile Settings</h2>
      <p>This section will be implemented in future updates.</p>
    </Container>
  </div>
);
